import { diagnosticsApi, type DxNamedMasterDto } from "@/api/diagnostics";
import { MasterListPage } from "./MasterListPage";
import { MasterFormPage } from "./MasterFormPage";
import { statusColumn, TextFieldCell, SwitchCell } from "./fields";

const BASE = "/diagnostics/containers";
const LIST_KEY = ["dx-containers"];

export function DiagnosticsContainersPage() {
  return (
    <MasterListPage<DxNamedMasterDto>
      breadcrumbs={["Diagnostics", "Masters"]}
      title="Containers"
      subtitle="Tubes and containers samples are collected into."
      queryKey={LIST_KEY}
      listFn={(inc) => diagnosticsApi.listContainers(inc)}
      deleteFn={diagnosticsApi.deleteContainer}
      basePath={BASE}
      newLabel="New container"
      labelOf={(r) => r.name}
      deleteNote="It will be refused if any lab test defaults to it or any collected sample refers to it."
      columns={[
        { field: "code", headerName: "Code", width: 160 },
        { field: "name", headerName: "Name", flex: 1, minWidth: 240 },
        statusColumn<DxNamedMasterDto>(),
      ]}
    />
  );
}

interface Values { code: string; name: string; isActive: boolean }

export function ContainerFormPage() {
  return (
    <MasterFormPage<Values, DxNamedMasterDto>
      breadcrumbs={["Diagnostics", "Containers"]}
      noun="container"
      basePath={BASE}
      listQueryKey={LIST_KEY}
      detailQueryKey={(id) => ["dx-container", id]}
      defaultValues={{ code: "", name: "", isActive: true }}
      getFn={diagnosticsApi.getContainer}
      toValues={(d) => ({ code: d.code, name: d.name, isActive: d.isActive })}
      createFn={(v) => diagnosticsApi.createContainer({ code: v.code.trim(), name: v.name.trim() })}
      updateFn={(id, v) => diagnosticsApi.updateContainer(id, { code: v.code.trim(), name: v.name.trim(), isActive: v.isActive })}
    >
      {({ control }, isEdit) => (
        <>
          <TextFieldCell control={control} name="code" label="Code" span={4} required />
          <TextFieldCell control={control} name="name" label="Name" span={8} required />
          {isEdit && <SwitchCell control={control} name="isActive" label="Active" />}
        </>
      )}
    </MasterFormPage>
  );
}
